/**
 * @ngdoc controller
 * @name CommunityController
 * @description
 * This component renders the Community section.
 *
 * @memberof community
 */
class CommunityController {
  /**
   * Class constructor
   * @param {Service} $location          To redirect the user when the app needs to be updated.
   * @param {Object}  $rootScope         To broadcast the tracking events.
   * @param {Service} appConstant        To get the profile loadingTemplates size.
   * @param {Service} campaignsService   To get the list of campaigns.
   * @param {Service} communityService   To get the list of media.
   * @param {Service} errorHandler       To show any errors.
   * @param {Service} uploadQueue        We're going to need this to allow upload on this section.
   * @param {Object}  TRACKING_EVENTS    To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    appConstant,
    campaignsService,
    communityService,
    errorHandler,
    uploadQueue,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `campaignsService` service.
     * @type {Object}
     */
    this.campaignsService = campaignsService;
    /**
     * The local reference to the `communityService` service.
     * @type {Object}
     */
    this.communityService = communityService;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * Local reference for the upload Queue Service.
     * @type {Service}
     */
    this.uploadQueue = uploadQueue;
    /**
     * The local reference to the `media` array.
     * @type {Null|Array}
     */
    this.media = null;
    /**
     * The local reference to the `campaigns` array.
     * @type {?Array}
     */
    this.campaigns = null;
    /**
     * List of place holder; we need a list to iterate on the template.
     * @type {Array}
     */
    this.loadingItems = new Array(appConstant.pagination.profile.loadingTemplates);
    /**
     * The local reference to the `validSections` array.
     * @type {Array}
     */
    this.validSections = ['community', 'campaign'];
    /**
     * The local reference to the `sectionData` object.
     * @type {Object}
     */
    this.sectionData = {};
  }
  /**
   * Handle the load of the media.
   * @param {Boolean} first flag to get the Media
   *                  for the first time or load more.
   */
  _loadMedia(first) {
    this.communityService.load(first).then((media) => {
      this.media = media;
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  /**
   * Handle the load of the campaings.
   * @param {Boolean} first flag to get the Campaings
   *                  for the first time or load more.
   */
  _loadCampaings(first) {
    this.campaignsService.load(first).then((campaigns) => {
      this.campaigns = campaigns;
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  /**
   * Initialize variables.
   */
  $onInit() {
    this.activeSection = this.$location.hash() || this.validSections[0];
    // Check if the activeSection is a valid one, if not set the default one
    if (!this.validSections.includes(this.activeSection)) {
      this.changeActiveSection(this.validSections[0]);
    }

    // Fill the sectionData map
    this.sectionData[this.validSections[0]] = {
      load: this._loadMedia.bind(this),
      service: this.communityService,
    };
    this.sectionData[this.validSections[1]] = {
      load: this._loadCampaings.bind(this),
      service: this.campaignsService,
    };

    // Load the data
    this._loadMedia(true);
    this._loadCampaings(true);
  }
  /**
   * Handle the infinite scroll load more.
   */
  loadMore() {
    this.sectionData[this.activeSection].load(false);
  }
  /**
   * Handle the infinite scroll disable status.
   */
  hasMoreData() {
    return this.sectionData[this.activeSection].service.hasMoreData();
  }
  /**
   * Change the active section.
   */
  changeActiveSection(section) {
    this.activeSection = section;
    this.$location.hash(section);
  }
  /**
   * Add the FILE oject to the upload queue service.
   * @param {FileList} selectedFiles list of seleted files by the user.
   * @param {Object} campaign        the campaign Object to assign to the Media.
   */
  fileSelected(selectedFiles, campaign) {
    this.uploadQueue.addItems(selectedFiles, campaign);
    this.$location.url(campaign ? `/upload/${campaign.id}` : '/upload');
  }
  /**
   * Track the click event.
   * @param {String} type the type of click event to track.
   */
  trackClick(type) {
    this.$rootScope.$broadcast(this.TRACKING_EVENTS.community[`click${type}`]);
  }
}

export default CommunityController;



// WEBPACK FOOTER //
// ./src/frontend/modules/community/components/community/community.controller.js